import { supabase } from '../lib/supabase';

export const goalsService = {
  // Get user goals by horizon
  async getUserGoals(userId, horizon = null) {
    try {
      let query = supabase?.from('user_goals')?.select('*')?.eq('user_id', userId)?.order('order_index')?.order('created_at')

      if (horizon) {
        query = query?.eq('horizon', horizon)
      }

      const { data, error } = await query

      if (error) {
        return { goals: [], error }
      }

      return { goals: data || [], error: null }
    } catch (error) {
      return { 
        goals: [], 
        error: { message: 'Failed to load goals.' }
      }
    }
  },

  // Create a new goal
  async createGoal(userId, goalData) {
    try {
      const { data, error } = await supabase?.from('user_goals')?.insert([{
          user_id: userId,
          horizon: goalData?.horizon,
          goal_text: goalData?.text,
          is_completed: false,
          order_index: goalData?.orderIndex || 0
        }])?.select()?.single()

      return { goal: data, error }
    } catch (error) {
      return { 
        goal: null, 
        error: { message: 'Failed to create goal.' }
      }
    }
  },

  // Update goal
  async updateGoal(goalId, updates) {
    try {
      const updateData = {}
      
      if (updates?.text !== undefined) {
        updateData.goal_text = updates?.text
      }
      if (updates?.completed !== undefined) {
        updateData.is_completed = updates?.completed
        updateData.completed_at = updates?.completed ? new Date()?.toISOString() : null
      }
      if (updates?.orderIndex !== undefined) {
        updateData.order_index = updates?.orderIndex
      }

      const { data, error } = await supabase?.from('user_goals')?.update(updateData)?.eq('id', goalId)?.select()?.single()

      return { goal: data, error }
    } catch (error) {
      return { 
        goal: null, 
        error: { message: 'Failed to update goal.' }
      }
    }
  },

  // Delete goal
  async deleteGoal(goalId) {
    try {
      const { error } = await supabase?.from('user_goals')?.delete()?.eq('id', goalId)

      return { error }
    } catch (error) {
      return { 
        error: { message: 'Failed to delete goal.' }
      }
    }
  },

  // Toggle goal completion
  async toggleGoalCompletion(goalId, completed) {
    return this.updateGoal(goalId, { completed })
  }
}